import {
  BasicInfoSupplier,
  ActivityAreaForm,
  BankForm,
  DocumentsEquipmentSupplier,
  UpdateDocumentsEquipmentSupplier,
  DocumentsSupplier,
  TermsSupplier,
  ObjectionSupplier,
} from './components';
import { AuditorForm } from '../mainFormAuditor/components';
import { ocForm } from '../mainFormOC/components';
import { tabs } from './components/basicInfoSupplier/tabs';
import { isEmpty, isNil } from 'lodash';

export const stepsSupplier = ({ isDirectSupplier, isIndirectSupplier, activeTaskName, auditorComment, objCommentBen, objectionCommitteeComment }) =>  {
  return [
  {
    name: 'BASICFORMSUPPLIER',
    label: 'Βασικά Στοιχεία Προμηθευτή',
    Component: BasicInfoSupplier,
    tabsComponent : tabs({ isDirectSupplier, isIndirectSupplier }),
    subtabs: true,
    id: 0,
  },
  {
    name: 'AREAFORM',
    label: 'Περιοχή Δραστηριότητας',
    Component: ActivityAreaForm,
    id: 1,
    hidden: !isDirectSupplier,
  },
  {
    name: 'BANKFORM',
    label: 'Στοιχεία Πιστωτικού Ιδρύματος',
    Component: BankForm,
    id: 2,
    hidden: !isDirectSupplier,
  },
  {
    name: 'EQUIPMENTDOCUMENT',
    label: 'Εξοπλισμός',
    Component: DocumentsEquipmentSupplier,
    id: 3,
    hidden: !isIndirectSupplier,
  },
  {
    name: 'DOCUMENTS',
    label: 'Έγγραφα',
    Component: DocumentsSupplier,
    id: 4,
    hidden: !isDirectSupplier,
  },
  {
    name: 'TERMS',
    label: 'Όροι και Προϋποθέσεις',
    Component: TermsSupplier,
    id: 5,
  },
  {
    name: 'EVALUATIONFORM',
    label: 'Αξιολόγηση Αίτησης',
    Component: AuditorForm,
    hidden: (isNil(auditorComment) || (auditorComment && (activeTaskName === "task.name.application_evaluation_by_auditor" || activeTaskName === "task.name.application_returned_to_supplier"))),
    id: 6,
  },
  {
    name: 'OBJECTIONFORM',
    label: 'Ένσταση',
    Component: ObjectionSupplier,
    id: 7,
    hidden: !((!isNil(auditorComment) && activeTaskName === "task.name.temporary_rejected") || !isNil(objCommentBen)),
  },
  {
    name: 'OBJECTIONEVALUATIONFORM',
    label: 'Αξιολόγηση Ένστασης',
    Component: ocForm,
    id: 8,
    hidden: !(!isNil(objectionCommitteeComment) && (activeTaskName === "task.name.accepted" || activeTaskName === "task.name.final_rejected")),
  },
  {
    name: 'UPDATEEQUIPMENTDOCUMENT',
    label: 'Ανανέωση Εξοπλισμού',
    Component: UpdateDocumentsEquipmentSupplier,
    id: 8,
    hidden: !((activeTaskName === "task.name.accepted") && isIndirectSupplier),
  },

].filter(item => !item?.hidden)
};